import { render, staticRenderFns } from "./ManageMenuItemForm.vue?vue&type=template&id=e296f1ec&"
import script from "./ManageMenuItemForm.vue?vue&type=script&lang=js&"
export * from "./ManageMenuItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports